import React from 'react';

const AlertIcon = () => {
	return (
		<svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12 2L2 20h20L12 2zm0 3.5L19.5 19h-15L12 5.5zM11 10v4h2v-4h-2zm0 5v2h2v-2h-2z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default AlertIcon;
